import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getEstablishmentAssignationList as getEstablishmentAssignationListApi,
	getEstablishmentAssignation as getEstablishmentAssignationApi,
	addNewEstablishmentAssignation as addNewEstablishmentAssignationApi,
	updateEstablishmentAssignation as updateEstablishmentAssignationApi,
	deleteEstablishmentAssignation as deleteEstablishmentAssignationApi,
} from '../../helpers/auth/backend_helper';

export const getEstablishmentAssignationList = createAsyncThunk('establishmentAssignations/getEstablishmentAssignationList', async (params) => {
	try {
		const response = getEstablishmentAssignationListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getEstablishmentAssignation = createAsyncThunk('establishmentAssignations/getEstablishmentAssignation', async establishmentAssignationId => {
	try {
		const response = getEstablishmentAssignationApi(establishmentAssignationId);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewEstablishmentAssignation = createAsyncThunk('establishmentAssignations/addNewEstablishmentAssignation', async establishmentAssignation => {
	try {
		const response = addNewEstablishmentAssignationApi(establishmentAssignation);
		toast.success('Conversión agregada exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar conversión.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateEstablishmentAssignation = createAsyncThunk('establishmentAssignations/updateEstablishmentAssignation', async (establishmentAssignation) => {
		try {
			const response = updateEstablishmentAssignationApi(establishmentAssignation);
			toast.success('Conversión actualizada exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar conversión.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteEstablishmentAssignation = createAsyncThunk('establishmentAssignations/deleteEstablishmentAssignation', async establishmentAssignation => {
	try {
		const response = await deleteEstablishmentAssignationApi(establishmentAssignation);
		toast.success('Conversión eliminada exitosamente.', { autoClose: 3000 });
		return { establishmentAssignation, ...response };
	} catch (error) {
		toast.error('Error al eliminar conversión.', { autoClose: 3000 });
		throw new Error(error);
	}
});